export enum WsStatusTypes {
  DISCONNECTED,
  CONNECTING,
  CONNECTED,
  ERROR,
}
